import {type JSONData} from "../../base_classes/dto.d";
import {Dto} from "../../base_classes/dto";
import {type IAdministrationDto} from "./dto.gen.d";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class AdministrationDto extends Dto implements IAdministrationDto {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = '/administration/{id}';
  _reference = '/Administration/{id}';

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  name = '';

  fromEmailAddress = '';

  customerApproveSampleTemplateId: string = '';

  customerPrintingOrderReceivedTemplateId: string = '';

  customerTrackAndTraceTemplateId: string = '';

  supplierPrintingOrderReceivedTemplateId: string = '';

  supplierSampleAcceptedTemplateId: string = '';

  supplierSampleRejectedTemplateId: string = '';

  storeId: number = 1;

  magentoOptionIdConfigurator = 0

  configuratorApiUrl = ''

  configuratorApiUsername = ''

  configuratorApiToken = ''

  bearerToken = ''

  skus: string[] = [];

  /// ///////////////////////////////////////
  /// ///////////// METHODS /////////////////
  /// ///////////////////////////////////////

  static FromJSON(data: unknown): AdministrationDto {
    // Create a new instance of the class
    const obj = new AdministrationDto();
    obj.set(data as JSONData);
    return obj;
  }

  static FromJSONArray(data: unknown[]): AdministrationDto[] {
    return data.map((item) => AdministrationDto.FromJSON(item));
  }

  override set(data: JSONData): void {
    super.set(data);

    // Implement variables here
    if (data.name !== undefined && data.name !== null) {
      this.name = (data.name as string) ?? this.name;
    }
    if (data.fromEmailAddress !== undefined && data.fromEmailAddress !== null) {
      this.fromEmailAddress = (data.fromEmailAddress as string) ?? this.fromEmailAddress;
    }
    if (data.customerApproveSampleTemplateId !== undefined && data.customerApproveSampleTemplateId !== null) {
      this.customerApproveSampleTemplateId = (data.customerApproveSampleTemplateId as string) ?? this.customerApproveSampleTemplateId;
    }
    if (data.customerPrintingOrderReceivedTemplateId !== undefined && data.customerPrintingOrderReceivedTemplateId !== null) {
      this.customerPrintingOrderReceivedTemplateId = (data.customerPrintingOrderReceivedTemplateId as string) ?? this.customerPrintingOrderReceivedTemplateId;
    }
    if (data.customerTrackAndTraceTemplateId !== undefined && data.customerTrackAndTraceTemplateId !== null) {
      this.customerTrackAndTraceTemplateId = (data.customerTrackAndTraceTemplateId as string) ?? this.customerTrackAndTraceTemplateId;
    }
    if (data.supplierPrintingOrderReceivedTemplateId !== undefined && data.supplierPrintingOrderReceivedTemplateId !== null) {
      this.supplierPrintingOrderReceivedTemplateId = (data.supplierPrintingOrderReceivedTemplateId as string) ?? this.supplierPrintingOrderReceivedTemplateId;
    }
    if (data.supplierSampleAcceptedTemplateId !== undefined && data.supplierSampleAcceptedTemplateId !== null) {
      this.supplierSampleAcceptedTemplateId = (data.supplierSampleAcceptedTemplateId as string) ?? this.supplierSampleAcceptedTemplateId;
    }
    if (data.supplierSampleRejectedTemplateId !== undefined && data.supplierSampleRejectedTemplateId !== null) {
      this.supplierSampleRejectedTemplateId = (data.supplierSampleRejectedTemplateId as string) ?? this.supplierSampleRejectedTemplateId;
    }
    if (data.storeId !== undefined && data.storeId !== null) {
      this.storeId = (data.storeId as number) ?? this.storeId;
    }
    if (data.magentoOptionIdConfigurator !== undefined && data.magentoOptionIdConfigurator !== null) {
      this.magentoOptionIdConfigurator = (data.magentoOptionIdConfigurator as number) ?? this.magentoOptionIdConfigurator;
    }
    if (data.configuratorApiUrl !== undefined && data.configuratorApiUrl !== null) {
      this.configuratorApiUrl = (data.configuratorApiUrl as string) ?? this.configuratorApiUrl;
    }
    if (data.configuratorApiUsername !== undefined && data.configuratorApiUsername !== null) {
      this.configuratorApiUsername = (data.configuratorApiUsername as string) ?? this.configuratorApiUsername;
    }
    if (data.configuratorApiToken !== undefined && data.configuratorApiToken !== null) {
      this.configuratorApiToken = (data.configuratorApiToken as string) ?? this.configuratorApiToken;
    }
    if (data.bearerToken !== undefined && data.bearerToken !== null) {
      this.bearerToken = (data.bearerToken as string) ?? this.bearerToken;
    }
    if (data.skus !== undefined && data.skus !== null) {
      this.skus = Array.isArray(data.skus) ? data.skus as string[] : [];
    }
  }
}
